import moment from 'jalali-moment'
import React from 'react'
interface IItemProps {
    item: IRejectedDemandLoan
}
export default function DetailRejected({ item }: IItemProps) {
    return (
        <div className=" my-2 text-sm">
            <hr className=" text-red-1 bg-red-1" />
            <div className=" w-full flex justify-between my-2">
                <p>تاریخ ثبت درخواست</p>
                <p>
                    {moment
                        .from(item.created, 'YYYY-MM-DD')
                        .locale('fa')
                        .format('YYYY/MM/DD')}
                </p>
            </div>
            <div className=" w-full flex justify-between my-2">
                <p>ساعت ثبت درخواست</p>
                <p>
                    {moment
                        .from(item.created, 'YYYY-MM-DD')
                        .locale('fa')
                        .format('HH:mm:ss')}
                </p>
            </div>
            <div className=" w-full flex justify-between my-2">
                <p>توسط</p>
                <p>{item.rejecter ? item.rejecter.name : 'ثبت نشده'}</p>
            </div>
            <div className=" w-full flex justify-between my-2">
                <p>ساعت رد درخواست</p>
                <p>
                    {item.rejection_datetime
                        ? moment
                              .from(item.rejection_datetime, 'YYYY-MM-DD')
                              .locale('fa')
                              .format('HH:mm:ss')
                        : 'ثبت نشده'}
                </p>
            </div>
        </div>
    )
}
